import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ArchWindow } from "../components/ArchWindow";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts++ > 8) { setState("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setAmount(data.amount ? (data.amount / 100).toFixed(2) : null);
          setState("paid");
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch (e) { /* keep polling */ }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FFF5F2] flex items-center justify-center px-6">
      <div className="glass rounded-2xl p-12 max-w-lg w-full text-center" data-testid="payment-success-card">
        <div className="flex justify-center"><ArchWindow size={44} /></div>
        {state === "checking" && (
          <>
            <h1 className="font-orbitron font-bold text-xl text-[#120716] mt-8">CONFIRMING YOUR GIFT...</h1>
            <p className="mt-4 text-sm text-[#120716]/60">Please wait while we verify your donation with Stripe.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <h1 className="font-orbitron font-bold text-xl text-[#120716] mt-8" data-testid="payment-success-title">THANK YOU{amount ? ` FOR YOUR $${amount} GIFT` : ""}!</h1>
            <p className="mt-4 text-sm text-[#120716]/70 leading-relaxed">
              Your gift just put a church one step closer to being found. Thank you for building this with me.
            </p>
            <blockquote className="mt-6 italic font-light text-[#C13B3B] text-sm">
              "Each one must give as he has decided in his heart, not reluctantly or under
              compulsion, for God loves a cheerful giver." — 2 Corinthians 9:7
            </blockquote>
          </>
        )}
        {(state === "error" || state === "timeout") && (
          <>
            <h1 className="font-orbitron font-bold text-xl text-[#120716] mt-8">
              {state === "timeout" ? "STILL PROCESSING" : "PAYMENT ISSUE"}
            </h1>
            <p className="mt-4 text-sm text-[#120716]/60">
              {state === "timeout"
                ? "Your payment is taking a moment. If you completed checkout, your gift will be recorded shortly."
                : "We couldn't confirm this payment. If you were charged, please contact us."}
            </p>
          </>
        )}
        <Link to="/" data-testid="payment-back-home" className="inline-block mt-8 rounded-full bg-[#E84C4C] hover:bg-[#f05e5e] text-white text-sm font-semibold px-8 py-3 transition-all">
          Back to the Mission
        </Link>
      </div>
    </div>
  );
}
